import { QueryKey } from '@tanstack/react-query';

const baseKey: QueryKey = ['subscriptions'] as const;
const baseURL = '/subscription';

const subscriptionsQueries = {
  base: baseKey,
  getLicences: [...baseKey, 'get-licences'],
  getInvoices: [...baseKey, 'get-invoices'],
  getBillingInfo: [...baseKey, 'get-billing-info'],
  getSubscriptions: [...baseKey, 'get-product-subscriptions'],
  createSetupIntent: [...baseKey, 'create-setup-intent'],
} as const;

const subscriptionsAPIUrls = {
  getLicences: baseURL + '/licences',
  getInvoices: baseURL + '/retrieve-invoices',
  getBillingInfo: baseURL + '/billing-info',
  getSubscriptions: baseURL + '/product-subscriptions',
  createSetupIntent: baseURL + '/create-setup-intent',
  updatePaymentMethod: baseURL + '/update-payment-method',
  updateBillingDetails: baseURL + '/update-billing-details',
  updateSubscription: baseURL + '/update-subscription',
};

export { subscriptionsAPIUrls, subscriptionsQueries };
